import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var EligibleAdyenCountriesPayoutsIA = function EligibleAdyenCountriesPayoutsIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "coXqX6",
    defaultMessage: [{
      "type": 0,
      "value": "Om betalingen te kunnen ontvangen, moet je een bankrekening koppelen aan je Faire-account. Zo werkt dat:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zna/Xg",
    defaultMessage: [{
      "type": 0,
      "value": "Ga naar je "
    }, {
      "children": [{
        "type": 0,
        "value": "Accountinstellingen"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qON8Bf",
    defaultMessage: [{
      "type": 0,
      "value": "Ga naar het tabblad "
    }, {
      "children": [{
        "type": 0,
        "value": "Uitbetalingen"
      }],
      "type": 8,
      "value": "LinkPayoutFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkPayoutFormatting: function LinkPayoutFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Ngu4q0",
    defaultMessage: [{
      "type": 0,
      "value": "Klik op "
    }, {
      "children": [{
        "type": 0,
        "value": "Uitbetalingsgegevens voltooien"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gTE6te",
    defaultMessage: [{
      "type": 0,
      "value": "Je wordt dan doorgestuurd naar Adyen om je account te configureren."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "CSeHu8",
    defaultMessage: [{
      "type": 0,
      "value": "Je uitbetalingen worden niet uitgevoerd totdat je bankrekening is geverifieerd door Adyen. Uitbetalingen worden vervolgens verwerkt volgens het uitbetalingsschema dat je hebt gekozen in je accountinstellingen."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};